import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material';

import { AddOneFromListDialogData } from './add-one-from-list-dialogdata';

@Component({
    selector : 'add-one-from-list-dialog',
    template: require('./add-one-from-list-dialog.component.html'),
    styles: [require('./add-one-from-list-dialog.component.scss')]
})
export class AddOneFromListDialogComponent {
    public filter = '';
    public isClicked = false;
    public selectedBackup: any;
    constructor(@Inject(MAT_DIALOG_DATA) public data: AddOneFromListDialogData) {
    }
    public chooseBackup(check: any) {
        this.isClicked = !this.isClicked;
        this.selectedBackup = [check];
        check.selected = true;
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/shared/components/dialogs/add-one-from-list-dialog/add-one-from-list-dialog.component.ts